var map = {
  "./da.json": [
    "393",
    [
      23442
    ]
  ],
  "./fi.json": [
    "53427",
    [
      4304
    ]
  ],
  "./sv.json": [
    "91632",
    [
      9568
    ]
  ],
  "./ja.json": [
    "43751",
    [
      91820
    ]
  ],
  "./lt.json": [
    "54154",
    [
      94743
    ]
  ],
  "./sl.json": [
    "2597",
    [
      82438
    ]
  ],
  "./fr.json": [
    "41674",
    [
      86359
    ]
  ],
  "./es.json": [
    "68978",
    [
      86863
    ]
  ],
  "./no.json": [
    "10417",
    [
      23242
    ]
  ],
  "./cs.json": [
    "96588",
    [
      86077
    ]
  ],
  "./en.json": [
    "15537",
    [
      47754
    ]
  ],
  "./description/en.json": [
    "63742",
    [
      33555
    ]
  ],
  "./pl.json": [
    "20358",
    [
      24587
    ]
  ],
  "./hu.json": [
    "78001",
    [
      14026
    ]
  ],
  "./nl.json": [
    "41956",
    [
      36101
    ]
  ],
  "./de.json": [
    "17917",
    [
      83342
    ]
  ],
  "./pt.json": [
    "12606",
    [
      48243
    ]
  ],
  "./it.json": [
    "91539",
    [
      72240
    ]
  ],
  "./et.json": [
    "91087",
    [
      13604
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 51647;
module.exports = __rspack_async_context;
